import React from "react"
import { useTranslation } from "next-i18next"
import Link from "next/link"
import tw from "twin.macro"
import { Routes } from "../../routes"

interface QATextProps {
  username: string
  name: string
  isAnswer: boolean
  date: string
  body: string
}

const QAText = (props: QATextProps) => {
  const { username, name, isAnswer, date, body } = props
  const { t } = useTranslation("question")

  return (
    <div data-testid={isAnswer ? "answer" : "question"} tw="space-y-4">
      <div tw="flex justify-between items-center space-x-2">
        <div tw="font-bold space-x-1">
          <Link href={{ pathname: Routes.Profile, query: { username: username } }} passHref>
            <a data-testid={isAnswer ? "artist-profile" : "fan-profile"} tw="text-purple hover:underline">
              {name}
            </a>
          </Link>
          <span>{isAnswer ? t("answered") : t("asked")}</span>
        </div>
        <span
          data-chromatic="ignore"
          data-testid={isAnswer ? "transcription-created-at" : "question-created-at"}
          tw="font-bold text-base-4 text-sm whitespace-nowrap"
        >
          {date}
        </span>
      </div>
      <div tw="space-y-2 text-md font-medium">
        <p>{body}</p>
      </div>
    </div>
  )
}

export default QAText
